import './buttonLogin.css';

const ButtonLogin = ({ children, click }) => {
    const handleClick = (event) => {
        event.preventDefault();
        click()
    };

    return (
        <button type='submit' className='button-login' onClick={handleClick}>{children}</button>
    );
};

export default ButtonLogin;